import { Box, Card, CardMedia, Grid, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
	media: {
		width: "100%",
		height: "200px",
		objectFit: "contain",
	},
	blink: {
		animation: `$blinkAnimation 1s step-start 0s infinite`,
	},
	"@keyframes blinkAnimation": {
		"50%": { opacity: 0 },
	},
}));

export const HiConnectionState = {
	Undefined: 0,
	NotConnected: 1,
	Detecting: 2,
	Detected: 3,
	Activating: 4,
	Activated: 5,
	Connecting: 6,
	Connected: 7,
	Disconnected: 8,
	Failed: 9,
	HiMisMatch: 10,
	Completed: 11
};

export default function LinkHiStatus({ splittype, splitdata }) {
	const classes = useStyles();
	const { t } = useTranslation();
	if (!splitdata) {
		return <Card>{t("connection.status.noDevice")}</Card>;
	}

	const { state, data, success } = splitdata;
	console.log("LinkHiStatus", state, splitdata);
	const getMessage = () => {
		switch (state) {
			case HiConnectionState.Undefined:
				return t('connection.status.unknown');
			case HiConnectionState.NotConnected:
				return t('connection.status.notConnected');
			case HiConnectionState.Detecting:
			case HiConnectionState.Detected:
			case HiConnectionState.Activating:
				return t('connection.status.activating');
			case HiConnectionState.Activated:
			case HiConnectionState.Connected:
				return t('connection.status.connected');
			case HiConnectionState.Connecting:
				return t('connection.status.connecting');
			case HiConnectionState.Disconnected:
				return t('connection.status.disconnected');
			case HiConnectionState.Failed:
				return t('connection.status.failed');
			case HiConnectionState.HiMisMatch:
				return t('connection.status.mismatch');
			default:
				return t('connection.status.unknown');
		}
	};

	return (
		<Grid container alignItems="center">
			<Grid item xs={12}>
				<Alert
					variant="filled"
					severity={state === HiConnectionState.Failed ? "error" : "success"}
				>
					{getMessage()}
				</Alert>
			</Grid>
			{splitdata.data && (
				<>
					<Grid item xs={4}>
						<CardMedia className={classes.media} image={data.ImageUrl} />
					</Grid>
					<Grid item xs={8}>
						<Box textAlign="center">
							<Typography variant="h5" color="textPrimary" display="inline"
							className={state === HiConnectionState.HiMisMatch ? classes.blink : ""}>
								{data.DisplayName}
							</Typography>
							<Typography
								variant="body2"
								color="textSecondary"
								style={{ overflow: "hidden" }}
							>
								{data.HiSerialNumber}
							</Typography>
						</Box>
					</Grid>
				</>
			)}
		</Grid>
	);
}
